import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RapoarteService {
    private basePath = environment.interop.basePath;

    private downloadRaportUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.raportDownload;

    constructor(private http: HttpClient) { }

    downloadRaport(nrDays: number, showAll: boolean) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        });

        return this.http.post(this.downloadRaportUrl, { number_of_days: nrDays, show_all: showAll }, { headers: headers, responseType: 'blob' as 'json' });
    }
}
